var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('smart-duo',{attrs:{"filterOptionsUrl":"/ConsentForm/DigitalSignatureConsentFormVue"}}),_c('DigitalSignatureSendModal',{ref:"digitalSignatureSendModal",on:{"sent":_vm.onDigitalSignatureSent}}),_c('DigitalSignatureAnswersModal',{ref:"digitalSignatureAnswersModal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }